import { Link } from "react-router-dom";
import { ArrowUpRight, Lock } from "lucide-react";
import SectionLabel from "../../../components/SectionLabel";

export default function NextProject({ nextProject }) {
    if (!nextProject) return null;
    return (
        <section className="section-pad bg-[#0B0B0C] border-t border-[rgba(201,168,106,0.15)] overflow-hidden">
            <div className="shell">
                <SectionLabel number="—" label="Next in the Collection" />
                <Link
                    to={`/private/projects/${nextProject.slug}`}
                    className="group block mt-8 max-w-4xl"
                    data-testid={`private-next-${nextProject.slug}`}
                >
                    <div className="flex items-start justify-between gap-6">
                        <div>
                            <div className="flex items-center gap-3 mb-3">
                                <span className="text-[11px] tracking-[0.28em] uppercase text-[#9A958A]">
                                    {nextProject.location}
                                </span>
                                {nextProject.private_only && (
                                    <span className="inline-flex items-center gap-1 border border-[#C9A86A]/60 text-[10px] tracking-[0.22em] uppercase text-[#C9A86A] px-2 py-0.5">
                                        <Lock size={10} strokeWidth={1.6} />
                                        Exclusive
                                    </span>
                                )}
                            </div>
                            <h3 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#F3EFE7] leading-[1.05] transition-colors duration-500 group-hover:text-[#D9BC80]">
                                {nextProject.name}
                            </h3>
                        </div>
                        <span className="inline-flex items-center justify-center w-12 h-12 border border-[#C9A86A]/50 text-[#C9A86A] transition-all duration-500 ease-out group-hover:bg-[#C9A86A] group-hover:text-[#0B0B0C] shrink-0 mt-2">
                            <ArrowUpRight
                                size={18}
                                strokeWidth={1.1}
                            />
                        </span>
                    </div>
                </Link>
            </div>
        </section>
    );
}
